export default "__VITE_ASSET__CIXglAMF__"